import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { fetchCountries } from '../../actions';
import { selectCountries, selectCompanyPropertyNames } from '../../selectors';
import { selectNewCompany } from '../../selectors';
import { selectAddressTypes } from '../../../Address/selectors';
import { parseCompany } from '../../helpers';
import { Checkbox } from '../../../../components/Checkbox';
import { CompanyAddressModal } from '../../components/CompanyAddressModal';
import { makeSelectLocale } from '../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../translate-countries';

const STATE = {
  edit: null,
  value: '',
  addCompanyAddress: false,
  addValue: '',
  deleteAddressConfirm: null,
  addCountryId: null,
  address: { countryId: null, typeId: null },
  fieldErrors: null,
  standardLocation: null,
  currentStandard: null,
};

const Container = styled.div`
  width: 100%;
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const Address = styled.div`
  border: 1px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  width: 30%;
  margin-right: 3%;
  margin: 6px 1.5%;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  min-height: 200px;
  border: 1px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  margin-right: 3%;
  margin: 6px 1.5%;
`;

/* eslint-disable react/prefer-stateless-function */
class CompanyAddressesComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    if (!this.props.countries) {
      this.props.fetchCountries();
    }

    const standardLocationId = this.props.company?.properties?.find(p => p?.name?.name === 'transport_location_id')?.value;
    this.setState({
      standardLocation: standardLocationId,
      address: { ...this.state.address, typeId: this.props.addressTypes.filter(t => t.name === 'delivery')[0].id },
    });
  }

  editAddress(address) {
    this.setState({ edit: address.id, address });
  }

  reset() {
    this.setState({ ...STATE });
  }

  get company() {
    return this.props.company;
  }

  get address() {
    return this.props.address ?? {};
  }

  get countries() {
    return this.props.countries;
  }

  get addressTypes() {
    return this.props.addressTypes;
  }

  get locale() {
    return this.props.locale;
  }

  get isStandartLocation() {
    return parseCompany(this.props.company).properties.filter(prop => prop.name.name === 'transport_location_id')[0]?.value;
  }

  render() {
    const company = this.props.company;

    return (
      <Container>
        {!!this.state.addCompanyAddress && (
          <CompanyAddressModal
            companyId={this.props.company.id}
            standardId={this.state.standardLocation}
            address={this.state.address}
            isEdit={false}
            toggle={() => this.setState({ addCompanyAddress: false })}
          />
        )}
        <h2>{this.lbl('company.details.transportlocaties')}</h2>

        {!!this.countries?.length && !!this.addressTypes?.length && (
          <HBox flexWrap left>
            {company?.addresses?.filter(a => a.typeId === this.state.address.typeId)?.map(a => this.renderAddress(a))}
            <ButtonContainer>
              <Button small onClick={this.setStateFn({ addCompanyAddress: true })}>
                {this.lbl('+')}
              </Button>
            </ButtonContainer>
          </HBox>
        )}
      </Container>
    );
  }

  renderAddress(address) {
    if (this.state.edit === address.id)
      return (
        <CompanyAddressModal
          companyId={this.props.company.id}
          standardId={this.state.standardLocation}
          isEdit={true}
          address={address}
          toggle={() => this.setState({ edit: null })}
        />
      );
    return (
      <Address key={`${address.id}`}>
        <VBox left>
          <HBox vCenter>
            <h3 className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</h3>
            <FontAwesomeIcon icon={faEdit} onClick={() => this.editAddress(address)} />
          </HBox>
          {/*<div>{address.type?.name}</div>*/}

          {/*<div>{address.addressLine2}</div>*/}
          <VBox className="address" left>
            <div>{address.addressLine1}</div>
            <div>
              {address.postcode} {address.city}
            </div>
            <div>{translateCountry(address.country?.name, this.locale)}</div>
          </VBox>

          <VBox className="address" left>
            <strong>{this.lbl('company.details.comment')}</strong>
            {address.description}
          </VBox>

          <HBox vCenter right className="address">
            {this.lbl('company.details.stadart')}
            <Checkbox
              checked={this.isStandartLocation == address.id}
              className={(address.id == this.isStandartLocation) && 'green'}
            />
          </HBox>
        </VBox>
      </Address>
    );
  }
}

CompanyAddressesComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    companyPropertyNames: selectCompanyPropertyNames(),
    countries: selectCountries(),
    addressTypes: selectAddressTypes(),
    values: selectNewCompany(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchCountries() {
      dispatch(fetchCountries());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyTransportLocations = compose(withConnect, withRouter, injectIntl)(CompanyAddressesComp);
